import { isServiceWorkerSupported } from '~/utils/shared/platform'
import useAsync from 'react-use/lib/useAsync'

const ServiceWorkerInformation = () => {
  const {
    loading: serviceWorkerRegistratedLoading,
    error: serviceWorkerRegistratedError,
    value: serviceWorkerRegistrated,
  } = useAsync(() => navigator.serviceWorker.getRegistrations())

  if (!serviceWorkerRegistrated || serviceWorkerRegistratedLoading) return

  return (
    <>
      <h2>Service Worker</h2>
      <div className='information'>
        <h3>Service worker suportado:</h3>
        <span>{isServiceWorkerSupported ? 'Sim' : 'Não'}</span>
      </div>
      <div className='information'>
        <h3>Service worker ativo:</h3>
        <span>{serviceWorkerRegistrated[0]?.active?.state ?? 'Nenhum Service Worker ativo'}</span>
      </div>
      <div className='information'>
        <h3>Suporte a periodic sync:</h3>
        <span>
          {serviceWorkerRegistrated[0] && 'periodicSync' in serviceWorkerRegistrated[0]
            ? 'Sim'
            : 'Não'}
        </span>
      </div>
    </>
  )
}

export default ServiceWorkerInformation
